
import mixins from "vue-typed-mixins";

import { IExecutionResponse } from "../../../Interface";

import { titleChange } from "@/components/mixins/titleChange";
import { nodeHelpers } from '@/components/mixins/nodeHelpers';
import { formatUtcDate } from '@/utils/date';
import InfoBox from '@/components/InfoBox.vue';
import { workflowPermission } from '@/components/mixins/permissions/workflow';


import WorkflowNameShort from "@/components/WorkflowNameShort.vue";
import ReadOnly from "@/components/MainHeader/ExecutionDetails/ReadOnly.vue";

export default mixins(
	titleChange,
	nodeHelpers,
	workflowPermission,
).extend({
	name: "ExecutionDetails",
	components: {
		WorkflowNameShort,
		ReadOnly,
		InfoBox,
	},
	data() {
		return {
			executionActive: '',
		};
	},
	computed: {
		openModeLabel() {
			if (this.canEditFlow()) {
				return 'Editar Fluxo'
			} else {
				return 'Abrir Fluxo'
			}
		},
		openModeDesc() {
			if (this.canEditFlow()) {
				return 'Abrir Fluxo em Modo Edição'
			} else {
				return 'Abrir Fluxo em Modo Visualização'
			}
		},
		executionId(): string | undefined {
			return this.$route.params.id;
		},
		executionFinished(): boolean {
			const fullExecution = this.$store.getters.getWorkflowExecution;

			return !!fullExecution && fullExecution.finished;
		},
		executionWaiting(): boolean {
			const fullExecution = this.$store.getters.getWorkflowExecution;

			return !!fullExecution && !!fullExecution.waitTill;
		},
		workflowExecution(): IExecutionResponse | null {
			return this.$store.getters.getWorkflowExecution;
		},
		workspace() {
			return this.$store.getters.workspace;
		},
	},
	methods: {
		redirectWorkflowExisting(workflowId, viewMode) {
			const mode = this.canEditFlow() ? 'Editar' : 'Visualizar';
			
			this.$router.push({
				name: 'NodeViewExisting',
				params: { name: workflowId, mode},
			});
		},
		formatDate(date) {
			return formatUtcDate(date, 'DD/MM/YYYY [às] HH[h]:mm[min]');
		},
		formatDuration(timestamp) {
			if (timestamp < '00:00:01') {
				return '00h:00min:01s';
			} else {
				let hours = timestamp.substring(0, 2) + 'h:';
				let minutes = timestamp.substring(3, 5) + 'min:';
				let seconds = timestamp.substring(6, 8) + 's';

				return hours + minutes + seconds;
			}
		},
		async getActiveExecution() {
			this.executionActive = await this.restApi().getExecutionById(this.workspace.id, this.executionId);
		},
		async openWorkflow(workflowId: string) {
			this.$titleSet(this.workflowName, "IDLE");
			// Change to other workflow
			this.$router.push({
				name: "NodeViewExisting",
				params: { name: workflowId },
			});
		},
	},
	mounted() {
		this.getActiveExecution();
	},
});
